import { APPLICATION_CONFIGURATION_KEY } from "@entries/constants";

// @ts-expect-error -- APPLICATION_CONFIGURATION_KEY is not typed on window
const old = window[APPLICATION_CONFIGURATION_KEY];
// @ts-expect-error -- APPLICATION_CONFIGURATION_KEY is not typed on window
window[APPLICATION_CONFIGURATION_KEY] = { ...old, segmentId: "uePDr3ubRAuwPSsX7yeKQ0PDFNcEpn4P" };
